import { atom } from "jotai";

export interface FeedbackDialogState {
  open: boolean;
  screenshotDataUrl: string | null;
}

export const FEEDBACK_DIALOG_INITIAL_STATE: FeedbackDialogState = {
  open: false,
  screenshotDataUrl: null
};

export const feedbackDialogAtom = atom<FeedbackDialogState>(FEEDBACK_DIALOG_INITIAL_STATE);
